export enum OperationInitiator {
    User = 'User',
    Service = 'Service',
}
